import { useMutation } from "@tanstack/react-query";
import { vaultApi } from "../../../api/vault.api";

export function useValidatePoaByIdentity() {
  return useMutation({
    mutationFn: ({
      poaId,
      identityReqId,
    }: {
      poaId: string;
      identityReqId: string;
    }) => vaultApi.validateProofOfAddressByIdentity(poaId, identityReqId),
  });
}
